import { ajaxCall } from "./ajax-call";
import { initEmblaCarousels } from './embla-slider';

const postRelatedBooksSelector = '.js-post-related-books';

const setupPostRelatedBooks = async () => {
    const postRelatedBooks = document.querySelector(postRelatedBooksSelector);
    if (!postRelatedBooks) return;
  
    const isbns = postRelatedBooks.dataset.isbns;
    try {
        await ajaxCall('', postRelatedBooks, 'upt_ajax_post_related_books', isbns);
        const newCarousel = postRelatedBooks.querySelector(
          ".upt-posts-related-books"
        );
        initEmblaCarousels(newCarousel);
      } catch (error) {
        console.error('Failed to load related books via AJAX:', error);
        postRelatedBooks.style.display = 'none';
      }
};

document.addEventListener("DOMContentLoaded", () => {
    setupPostRelatedBooks();
});   

